import React, { Fragment, useEffect, useState } from "react";
import { PickupAddress } from "components/v1/Orders/Address";
import Header from "components/v1/common/Header";
import { StyledExchange } from "components/v1/ReturnCart/styled";
import { getMerchantConfig, getRmsConfig } from "features/config/configSlice";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getEncipherencode } from "utils/encipherencode";
import {
  paymentStatus,
  selectedReturnOrderAPI,
  updateShippingDetails,
} from "utils/api";
import { getReturnOrder } from "features/orders/orderSlice";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Drawer,
  Grid,
  Skeleton,
  Step,
  StepContent,
  StepLabel,
  Stepper,
} from "@mui/material";
import styled from "styled-components";
import CartProducts from "components/v1/common/CartProducts/CartProducts";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { format } from "date-fns";
import Comment from "./Comment";
import {
  StyledApp,
  StyledComments,
  StyledExchangePaymentDetails,
  StyledTracking,
} from "./styled";
import ModalImage from "react-modal-image";
import { getEmail, getPhone } from "features/user/userSlice";
import { ReactComponent as CloseIcon } from "assets/close.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ReturnDetails from "components/v1/common/ReturnDetails";
import { StyledRefundDetails } from "components/v1/common/ReturnDetails/styled";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";
import LoadingError from "components/v1/common/LoadingError";
import {
  hasValidTrackingReference,
  stripVersionPrefix,
  versionedPath,
} from "utils/routes";
import { hasExchangeFulfillmentRequestType } from "utils/returnTypes";

function Tracking() {
  const { t } = useTranslation();
  const location = useLocation();
  const currentPath = stripVersionPrefix(location.pathname);
  const merchantConfig = useSelector(getMerchantConfig);
  const returnOrderId = useSelector(getReturnOrder);
  const validReturnOrderId = hasValidTrackingReference(returnOrderId)
    ? returnOrderId
    : null;
  const [returnItems, setReturnItems] = useState({});
  const [shippingDetails, setShippingDetails] = useState(false);
  const [uploads, setUploads] = useState(null);
  const [preview, setPreview] = useState(null);
  const [awbNumber, setAwbNumber] = useState(null);
  const [courierName, setCourierName] = useState(null);
  const [trackingLink, setTrackingLink] = useState(null);
  const [file, setFile] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const rmsConfig = useSelector(getRmsConfig);
  const [activeStep, setActiveStep] = useState(0);
  const [returnItemsLoader, setReturnItemsLoader] = useState(false);
  const navigate = useNavigate();
  const userPhone = useSelector(getPhone);
  const userEmail = useSelector(getEmail);
  const [blurTime, setBlurTime] = useState(0);
  const [apiErrorLoading, setApiErrorLoading] = useState(false);
  const [params, setParams] = useSearchParams();
  const encipherencode = getEncipherencode(params);
  const reference_id = params.get("rid");
  const validReferenceId = hasValidTrackingReference(reference_id)
    ? String(reference_id).trim()
    : null;
  const transaction_id =
    params.get("razorpay_invoice_id") || params.get("txn_id");
  const order_id = params.get("order_id");
  const create_request = params.get("cr") || true;

  const returnRequestOrderAPI = (merchantId, returnid) => {
    if (merchantId && merchantId !== null) {
      selectedReturnOrderAPI(merchantId, returnid, validReferenceId, false)
        .then((resp) => {
          setReturnItems(resp.data);
          if (
            resp.data.status === 100 ||
            resp.data.status === 101 ||
            resp.data.status === 102 ||
            resp.data.status === 700
          ) {
            setActiveStep(0);
          } else if (
            resp.data.status === 200 ||
            resp.data.status === 201 ||
            resp.data.status === 202 ||
            resp.data.status === 300 ||
            resp.data.status === 301 ||
            resp.data.status === 305 ||
            resp.data.status === 306
          ) {
            setActiveStep(1);
          } else if (
            resp.data.status === 302 ||
            resp.data.status === 303 ||
            resp.data.status === 304 ||
            resp.data.status === 400
          ) {
            setActiveStep(2);
          } else if (
            resp.data.status === 500 ||
            resp.data.status === 600 ||
            resp.data.status === 501 ||
            resp.data.status === 601
          ) {
            setActiveStep(4);
          }
          setReturnItemsLoader(false);
        })
        .catch((err) => {
          if (userPhone === "" && userEmail === "") {
            let url = "/";
            if (encipherencode) {
              url += `?encipherencode=${encipherencode}`;
            }
            navigate(url);
          } else {
            setApiErrorLoading(true);
          }
        });
    }
  };

  useEffect(() => {
    setReturnItemsLoader(true);
    if (
      !transaction_id &&
      !validReturnOrderId &&
      !validReferenceId
    ) {
      setReturnItemsLoader(false);
      navigate(versionedPath("/orders", location.pathname), { replace: true });
      return;
    }

    if (
      merchantConfig &&
      merchantConfig !== null &&
      Object.keys(merchantConfig).length > 0 &&
      merchantConfig.merchant_id !== null
    ) {
      if (transaction_id) {
        paymentStatus(
          merchantConfig.merchant_id,
          transaction_id,
          validReferenceId,
          order_id,
          false,
          create_request
        ).then((resp) => {
          const currentAccessToken = sessionStorage.getItem("access_token");
          if (!currentAccessToken) {
            sessionStorage.setItem("access_token", resp.data.access_token);
          }
          returnRequestOrderAPI(merchantConfig.merchant_id, validReturnOrderId);
        });
      } else {
        if (validReturnOrderId) {
          returnRequestOrderAPI(merchantConfig.merchant_id, validReturnOrderId);
        } else if (validReferenceId) {
          returnRequestOrderAPI(merchantConfig.merchant_id, null);
        }
      }
    }

    function callFocus() {
      if (document.hasFocus()) {
        setBlurTime(0);
      } else {
        setBlurTime(blurTime + 1);
      }
    }
    const interval = setInterval(() => callFocus(), 60000 * 5);
    return () => {
      clearInterval(interval);
    };
  }, [merchantConfig]);

  useEffect(() => {
    if (
      returnItems !== undefined &&
      returnItems.self_ship &&
      returnItems.self_ship !== null
    ) {
      if (returnItems.self_ship.awb_number !== null) {
        setDisabled(true);
        setPreview(
          `${rmsConfig.s3_url}${returnItems.self_ship.consignment_image}`
        );
      } else {
        setDisabled(false);
      }
      setCourierName(returnItems.self_ship.courier_company);
      setTrackingLink(returnItems.self_ship.tracking_link);
      setAwbNumber(returnItems.self_ship.awb_number);
    }
  }, [returnItems]);

  const updatedAddress = {
    addressLine1: returnItems.customer_address_line_1,
    addressLine2: returnItems.customer_address_line_2,
    pincode: returnItems.customer_address_pin,
    city: returnItems.customer_address_city,
    state: returnItems.customer_address_state,
  };

  const steps = [
    returnItems && Object.keys(returnItems).length > 0
      ? returnItems.status === 700
        ? t("tracking.requestRejected")
        : t("tracking.requestCreated")
      : t("tracking.requestCreated"),
    t("tracking.processingRequest"),
    t("tracking.pickupCompleted"),
    returnItems && Object.keys(returnItems).length > 0
      ? returnItems.status === 500
        ? t("tracking.refundInitiated")
        : returnItems.status === 501
        ? t("tracking.refundCompleted")
        : returnItems.status === 600
        ? t("tracking.exchangeInitiated")
        : returnItems.status === 601
        ? t("tracking.exchangeCompleted")
        : t("tracking.requestCompleted")
      : t("tracking.requestCompleted"),
  ];

  const [vertical, setVertical] = useState(
    window.innerWidth < 600 ? true : false
  );

  window.addEventListener("resize", () => {
    if (window.innerWidth < 600) {
      setVertical(true);
    } else {
      setVertical(false);
    }
  });

  const ColorlibConnector = styled(StepConnector)(() => ({
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: merchantConfig.primary_theme_color,
        border: !vertical
          ? `1px solid ${merchantConfig.primary_theme_color}`
          : "",
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: merchantConfig.primary_theme_color,
        border: !vertical
          ? `1px solid ${merchantConfig.primary_theme_color}`
          : "",
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      border: !vertical ? "1px dashed #5C5C5C" : "",
    },
  }));

  const returnDate =
    returnItems.created_at !== undefined &&
    returnItems.created_at !== null &&
    returnItems.created_at.split(".");

  const submitHandler = (e) => {
    e.preventDefault();
    updateShippingDetails(file).then((resp) => {
      // console.log(resp.data);
    });
    setDisabled(true);
    setShippingDetails(false);
  };

  const handleUploads = (e) => {
    setUploads(e.target.files[0]);
    setPreview(URL.createObjectURL(e.target.files[0]));
    let formData = new FormData();
    formData.append("file", e.target.files[0]);
    formData.append("merchant_id", merchantConfig.merchant_id);
    formData.append("return_request_id", returnItems.id);
    formData.append("awb_number", awbNumber);
    formData.append("tracking_link", trackingLink);
    formData.append("courier_company", courierName);
    setFile(formData);
  };

  return (
    <StyledApp>
      <Header />

      {apiErrorLoading ? (
        <LoadingError minHeight="80vh" />
      ) : returnItemsLoader ? (
        <div style={{ padding: "100px" }}>
          <Skeleton style={{ width: "100%" }} height={50} />
          <div style={{ display: "flex" }}>
            <Skeleton height={100} style={{ width: "47.5%" }} />
            <Skeleton
              height={100}
              style={{ marginLeft: "100px", width: "47.5%" }}
            />
          </div>
        </div>
      ) : (
        <StyledTracking>
          <div>
            <p className="order-id">
              {/* Order{" "} */}
              {returnItems?.order_name && returnItems.order_name !== ""
                ? returnItems.order_name
                : `#${returnItems.order_number}`}
              <span className="return-id" style={{ marginLeft: "10px" }}>
                ( Request ID - #{returnItems.reference_id} )
              </span>
            </p>
          </div>

          <p className="request-date">
            Requested on{" "}
            {returnDate[0] !== undefined &&
              format(new Date(returnDate[0]), "dd MMMM yyyy")}{" "}
          </p>

          <Stepper
            activeStep={activeStep}
            connector={<ColorlibConnector />}
            alternativeLabel={true}
            style={{ margin: "1.5rem 0" }}
            orientation="horizontal"
          >
            {steps.map((label, i) => (
              <Step key={label}>
                <StepLabel className="step-label">{label}</StepLabel>
                {(i == 0 || i == 1) &&
                  returnItems.shipment_handled_by == "customer" && (
                    <StepContent className="step-content">
                      <Button
                        variant="contained"
                        style={{
                          textTransform: "capitalize",
                          marginTop: "10px",
                        }}
                        onClick={() => setShippingDetails(true)}
                      >
                        {disabled ? "Check" : "Submit"} Shipping Details
                      </Button>
                    </StepContent>
                  )}
              </Step>
            ))}
          </Stepper>

          <StyledExchange
            location={currentPath}
            primaryColor={merchantConfig.primary_theme_color}
            style={{
              textAlign: "left",
              marginBottom: "40px",
              justifyContent: "space-between",
              border: "none",
              paddingTop: "10px",
            }}
          >
            <div className="products-return">
              {returnItems?.shipment_line_items &&
                returnItems?.shipment_line_items?.length > 0 && (
                  <div>
                    <p
                      className="product-details"
                      style={{
                        fontWeight: "600",
                        textAlign: "center",
                      }}
                    >
                      Shipment Details
                    </p>
                    {returnItems.shipment_line_items.map((item, i) => {
                      return (
                        <Accordion
                          className="shipment-accordion"
                          style={{
                            margin: "1rem 0px",
                            borderRadius:
                              merchantConfig.use_rounded_edge_buttons
                                ? "10px"
                                : "0px",
                            position: "relative",
                            // boxShadow: "none",
                          }}
                        >
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon
                                style={{
                                  color: merchantConfig.primary_theme_color,
                                  fontSize: "24px",
                                }}
                              />
                            }
                            aria-controls="panel1-content"
                            style={{
                              borderTopRightRadius:
                                merchantConfig.use_rounded_edge_buttons
                                  ? "10px"
                                  : 0,
                              borderTopLeftRadius:
                                merchantConfig.use_rounded_edge_buttons
                                  ? "10px"
                                  : 0,
                              padding: "0.5rem 1rem",
                            }}
                            sx={{
                              // border: `1px solid ${merchantConfig.primary_theme_color}`,
                              color: merchantConfig.primary_theme_color,
                              overflow: "hidden",
                              borderRadius:
                                merchantConfig.use_rounded_edge_buttons
                                  ? "10px"
                                  : "0px",
                              // when expanded, remove the overall rounding:
                              "&.Mui-expanded": {
                                borderRadius: 0,
                                margin: 0,
                              },
                              // always round the top of the summary:
                              "& .MuiAccordionSummary-root": {
                                borderTopLeftRadius:
                                  merchantConfig.use_rounded_edge_buttons
                                    ? "10px"
                                    : 0,
                                borderTopRightRadius:
                                  merchantConfig.use_rounded_edge_buttons
                                    ? "10px"
                                    : 0,
                                // when expanded, strip its bottom corners:
                                "&.Mui-expanded": {
                                  borderBottomLeftRadius: 0,
                                  borderBottomRightRadius: 0,
                                },
                              },
                              // always round the bottom of the details:
                              "& .MuiAccordionDetails-root": {
                                borderBottomLeftRadius:
                                  merchantConfig.use_rounded_edge_buttons
                                    ? "10px"
                                    : 0,
                                borderBottomRightRadius:
                                  merchantConfig.use_rounded_edge_buttons
                                    ? "10px"
                                    : 0,
                              },
                            }}
                          >
                            <p
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <a
                                href={item.tracking_url}
                                target="_blank"
                                style={{
                                  display: "flex",
                                  color: merchantConfig.primary_theme_color,
                                }}
                              >
                                {item.awb}{" "}
                                <OpenInNewIcon style={{ marginLeft: "4px" }} />
                              </a>{" "}
                              <span style={{ margin: "0px 6px" }}>
                                ({item.line_items.length} items)
                              </span>
                            </p>
                            <p
                              style={{
                                background: merchantConfig.primary_theme_color,
                                color: merchantConfig.secondary_theme_color,
                                borderBottomLeftRadius:
                                  merchantConfig.use_rounded_edge_buttons
                                    ? "10px"
                                    : "0px",
                                borderTopRightRadius:
                                  merchantConfig.use_rounded_edge_buttons
                                    ? "10px"
                                    : "0px",
                                padding: "1px 10px",
                                position: "absolute",
                                top: "-1px",
                                right: "-1px",
                                fontSize: "12px",
                              }}
                            >
                              {item?.shipment_status?.replaceAll("_", " ")}
                            </p>
                          </AccordionSummary>
                          <AccordionDetails
                            style={{
                              // background: `${merchantConfig.primary_theme_color}33`,
                              borderBottomLeftRadius:
                                merchantConfig.use_rounded_edge_buttons
                                  ? "10px"
                                  : "0px",
                              borderBottomRightRadius:
                                merchantConfig.use_rounded_edge_buttons
                                  ? "10px"
                                  : "0px",
                              padding: "1rem",
                              overflowX: "auto"
                            }}
                          >
                            <Stepper
                              activeStep={
                                Object.keys(item.steps).findIndex(
                                  (key) => !item.steps[key]
                                ) !== -1
                                  ? Object.keys(item.steps).findIndex(
                                      (key) => !item.steps[key]
                                    ) - 1
                                  : Object.keys(item.steps).length - 1
                              }
                              connector={<ColorlibConnector />}
                              alternativeLabel={true}
                              style={{ margin: "1rem 0" }}
                              orientation="horizontal"
                            >
                              {Object.keys(item.steps).map((label, i) => (
                                <Step key={label}>
                                  <StepLabel
                                    className="step-label"
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {label.replaceAll("_", " ")}
                                  </StepLabel>
                                </Step>
                              ))}
                            </Stepper>
                            <Grid
                              alignItems="center"
                              container
                              gridTemplateColumns="repeat(12, 1fr)"
                              columnSpacing={4}
                              className="cart-products"
                            >
                              {item.line_items.map((product, i) => {
                                return (
                                  <Grid
                                    key={i}
                                    justifyContent="center"
                                    item
                                    xs={12}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      <div className="image-preview-container">
                                        <LazyLoadImage
                                          effect="opacity"
                                          className="image-preview"
                                          src={product.variant_image_url}
                                          alt={product.product_title}
                                          style={{
                                            height: "30px",
                                            width: "30px",
                                          }}
                                        />
                                      </div>
                                      <div
                                        className="details"
                                        style={{
                                          marginLeft: "0.5rem",
                                          width: "100%",
                                        }}
                                      >
                                        <p
                                          className="title"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            width: "100%",
                                            marginTop: "0",
                                          }}
                                        >
                                          {product.product_title}{" "}
                                          <span style={{ marginLeft: "auto" }}>
                                            x{product.quantity}
                                          </span>
                                        </p>
                                        <p className="description">
                                          {product.variant_name !== null &&
                                          product.variant_name.indexOf(
                                            "Default"
                                          ) === -1
                                            ? product.variant_name
                                            : product.product_title}
                                        </p>
                                      </div>
                                    </div>
                                    {item.line_items.length - 1 !== i && (
                                      <hr style={{ margin: "1rem 0" }} />
                                    )}
                                  </Grid>
                                );
                              })}
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      );
                    })}
                  </div>
                )}

              {returnItems.accepted_line_items &&
                returnItems.accepted_line_items.length > 0 && (
                  <div>
                    <p
                      className="product-details"
                      style={{
                        fontWeight: "600",
                        textAlign: "center",
                      }}
                    >
                      Accepted Items
                    </p>

                    <div style={{ marginTop: "20px" }}>
                      <Grid
                        alignItems="center"
                        container
                        rowSpacing={{ xs: 2, md: 4 }}
                        gridTemplateColumns="repeat(12, 1fr)"
                        columnSpacing={4}
                        className="cart-products"
                      >
                        {returnItems.accepted_line_items.map((product, i) => {
                          return (
                            <Grid key={i} justifyContent="center" item xs={12}>
                              <CartProducts
                                cart_type="accepted"
                                product={product}
                                location={currentPath}
                              />
                            </Grid>
                          );
                        })}
                      </Grid>
                    </div>
                  </div>
                )}

              {returnItems.pending_line_items &&
                returnItems.pending_line_items.length > 0 && (
                  <div style={{ marginTop: "20px" }}>
                    <p
                      className="product-details"
                      style={{
                        fontWeight: "600",
                        textAlign: "center",
                      }}
                    >
                      Pending Items
                    </p>

                    <div style={{ marginTop: "20px" }}>
                      <Grid
                        alignItems="center"
                        container
                        rowSpacing={{ xs: 2, md: 4 }}
                        gridTemplateColumns="repeat(12, 1fr)"
                        columnSpacing={4}
                        className="cart-products"
                      >
                        {returnItems.pending_line_items.map((product, i) => {
                          return (
                            <Grid key={i} justifyContent="center" item xs={12}>
                              <CartProducts
                                cart_type="pending"
                                product={product}
                                location={currentPath}
                              />
                            </Grid>
                          );
                        })}
                      </Grid>
                    </div>
                  </div>
                )}

              {returnItems.rejected_line_items &&
                returnItems.rejected_line_items.length > 0 && (
                  <div style={{ marginTop: "20px" }}>
                    <p
                      className="product-details"
                      style={{
                        fontWeight: "600",
                        textAlign: "center",
                      }}
                    >
                      Rejected Items
                    </p>

                    <div style={{ marginTop: "20px" }}>
                      <Grid
                        alignItems="center"
                        container
                        rowSpacing={{ xs: 2, md: 4 }}
                        gridTemplateColumns="repeat(12, 1fr)"
                        columnSpacing={4}
                        className="cart-products"
                      >
                        {returnItems.rejected_line_items.map((product, i) => {
                          return (
                            <Grid key={i} justifyContent="center" item xs={12}>
                              <CartProducts
                                cart_type="rejected"
                                product={product}
                                location={currentPath}
                              />
                            </Grid>
                          );
                        })}
                      </Grid>
                    </div>
                  </div>
                )}
            </div>

            <div style={{ borderRight: "2px dashed #1111111A", flex: "0.1" }} />

            <div className="price-details">
              <div className="box" style={{ margin: "1rem 0" }}>
                {returnItems.exchange_payment_details &&
                  returnItems.exchange_payment_details.length > 0 &&
                  returnItems.exchange_payment_details.map((details) => {
                    return (
                      <div>
                        <p className="title">Exchange Payment Details</p>
                        <StyledRefundDetails
                          roundedEdgeButtons={
                            merchantConfig.use_rounded_edge_buttons
                          }
                          refundStatus={details.payment_status}
                        >
                          <div className="refund-details-header">
                            <div className="refund-details">
                              <div className="refund-title">
                                <p className="refund-amount">
                                  ₹ {details.amount}
                                </p>
                                <p className="refund-status">
                                  {details?.payment_status?.replaceAll(
                                    "_",
                                    " "
                                  )}
                                </p>
                              </div>
                            </div>
                            {details.tx_time && (
                              <div className="refund-time">
                                <p>
                                  {format(
                                    new Date(details.tx_time),
                                    "dd MMM yyyy"
                                  )}
                                </p>
                                <p>
                                  {format(
                                    new Date(details.tx_time),
                                    "hh:mm aa"
                                  )}
                                </p>
                              </div>
                            )}
                          </div>
                          <hr />
                          <div className="account-details">
                            <p>
                              Transaction ID:{" "}
                              <span style={{ fontWeight: "600" }}>
                                {details.transaction_id}
                              </span>
                            </p>
                            {details.payment_id && (
                              <p>Payment ID: {details.payment_id || "-"}</p>
                            )}
                          </div>
                          {(details.payment_status === "pending" ||
                            details.payment_status === "initiated") && (
                            <a
                              href={details.payment_url}
                              target="_blank"
                              style={{
                                color: merchantConfig.secondary_theme_color,
                                textDecoration: "none",
                              }}
                            >
                              <Button
                                variant="contained"
                                fullWidth
                                sx={{
                                  my: "1rem",
                                  backgroundColor: "#2817f0",
                                  "&:hover": { backgroundColor: "#2817f0" },
                                }}
                              >
                                Pay now
                              </Button>
                            </a>
                          )}
                        </StyledRefundDetails>
                      </div>
                    );
                  })}
              </div>

              {hasExchangeFulfillmentRequestType(returnItems.return_type) &&
                (returnItems.exchange_shipment_charge > 0 ||
                  returnItems.exchange_details.length > 0) && (
                  <ReturnDetails
                    infoType="Exchange"
                    returnType={returnItems.return_type}
                    returnItems={returnItems}
                    setReturnItems={setReturnItems}
                  />
                )}

              {(returnItems.return_type === "refund" ||
                returnItems.return_type === "refund_exchange" ||
                returnItems.refund_id) && (
                <ReturnDetails
                  infoType="Return"
                  returnType={returnItems.return_type}
                  returnItems={returnItems}
                  setReturnItems={setReturnItems}
                />
              )}
              <div
                className=""
                style={{
                  margin: !disabled ? "0px" : "10px 0px",
                  padding: "1rem",
                  boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                  borderRadius: merchantConfig.use_rounded_edge_buttons
                    ? "10px"
                    : "0px",
                }}
              >
                <PickupAddress
                  edit={false}
                  updatedAddress={updatedAddress}
                  disabled={disabled}
                  serviceable={true}
                  shipmentMethod={
                    returnItems.customer_preferred_return_shipment_method
                  }
                />
              </div>

              {returnItems.shipment_handled_by == "customer" ? (
                <div
                  className="shipping-address-details"
                  style={{
                    marginTop: "15px",
                    borderRadius: merchantConfig.use_rounded_edge_buttons
                      ? "10px"
                      : "0px",
                  }}
                >
                  <p
                    style={{
                      color: "rgb(51, 51, 51)",
                      fontSize: "18px",
                    }}
                  >
                    Ship your products back to
                  </p>
                  <p
                    style={{
                      color: "#3B444DB2",
                      marginTop: "5px",
                      padding: "5px 0px",
                      fontWeight: "400",
                    }}
                  >
                    {rmsConfig.return_address.name},{" "}
                    {rmsConfig.return_address.address_line_1},{" "}
                    {rmsConfig.return_address.address_line_2}{" "}
                    {rmsConfig.return_address.address_line_2 && ","}{" "}
                    {rmsConfig.return_address.city},{" "}
                    {rmsConfig.return_address.state},{" "}
                    {rmsConfig.return_address.country}, -{" "}
                    {rmsConfig.return_address.pin}
                  </p>
                </div>
              ) : (
                returnItems.status < 200 && (
                  <div
                    className="shipping-address-details"
                    style={{
                      borderRadius: merchantConfig.use_rounded_edge_buttons
                        ? "10px"
                        : "0px",
                      marginTop: "1rem",
                    }}
                  >
                    <p>
                      We will let you know the warehouse address if necessary
                      once your return request is accepted
                    </p>
                  </div>
                )
              )}
            </div>
          </StyledExchange>

          {Object.keys(returnItems).length > 0 &&
            rmsConfig.comments_section_visible && (
              <StyledComments>
                <Comment
                  fullName={
                    returnItems.customer_first_name +
                    " " +
                    returnItems.customer_last_name
                  }
                  return_request_id={returnItems.id}
                  blurTime={blurTime}
                />
              </StyledComments>
            )}

          <Drawer
            classes={{ paper: "paper-drawer" }}
            anchor="bottom"
            open={shippingDetails}
            onClose={() => setShippingDetails(false)}
          >
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.08)",
                  height: "80px",
                  padding: "32px",
                }}
              >
                <p
                  style={{ fontSize: "1rem", fontWeight: "500", color: "#3B444D" }}
                >
                  Enter Shipping Details
                </p>
                <p
                  style={{ cursor: "pointer" }}
                  onClick={() => setShippingDetails(false)}
                >
                  {" "}
                  <CloseIcon
                    style={{ width: "24px", height: "24px", stroke: "#3B444D" }}
                  />{" "}
                </p>
              </div>

              <form onSubmit={(e) => submitHandler(e)}>
                <div style={{ padding: "20px" }}>
                  <label style={{ display: "block" }}>
                    <span style={{ color: "#3B444DB2", fontSize: "14px" }}>
                      Courier Partner Name
                    </span>
                    <input
                      type="text"
                      value={courierName}
                      disabled={disabled}
                      onChange={(e) => setCourierName(e.target.value)}
                      required
                      style={{
                        width: "100%",
                        padding: "10px",
                        marginTop: "6px",
                        borderRadius: "4px",
                        border: "1px solid #D0D4E3",
                      }}
                      placeholder="Courier partner name"
                    />
                  </label>

                  <label style={{ display: "block", margin: "20px 0px" }}>
                    <span style={{ color: "#3B444DB2", fontSize: "14px" }}>
                      AWB Number
                    </span>
                    <input
                      type="text"
                      value={awbNumber}
                      disabled={disabled}
                      onChange={(e) => setAwbNumber(e.target.value)}
                      required
                      style={{
                        width: "100%",
                        padding: "10px",
                        marginTop: "6px",
                        borderRadius: "4px",
                        border: "1px solid #D0D4E3",
                      }}
                      placeholder="AWB"
                    />
                  </label>

                  <label style={{ display: "block", margin: "20px 0px" }}>
                    <span style={{ color: "#3B444DB2", fontSize: "14px" }}>
                      Tracking Link
                    </span>
                    <input
                      type="text"
                      value={trackingLink}
                      disabled={disabled}
                      onChange={(e) => setTrackingLink(e.target.value)}
                      required
                      style={{
                        width: "100%",
                        padding: "10px",
                        marginTop: "6px",
                        borderRadius: "4px",
                        border: "1px solid #D0D4E3",
                      }}
                      placeholder="Tracking Link"
                    />
                  </label>

                  <p style={{ color: "#3B444D99", fontSize: "14px" }}>
                    {" "}
                    Upload Receipt Image{" "}
                  </p>

                  {preview !== null ? (
                    <div
                      style={{
                        border: "1px solid #3B444D66",
                        display: "flex",
                        justifyContent: disabled ? "center" : "space-between",
                        alignItems: "center",
                        minWidth: "150px",
                        width: "100%",
                        marginRight: "20px",
                        marginTop: "20px",
                        borderRadius: "4px",
                        padding: "10px",
                      }}
                    >
                      {/* <img src={preview} alt="preview" style={{width: '40px', height: '40px'}} /> */}
                      <div style={{ width: "100px" }}>
                        <ModalImage
                          small={preview}
                          large={preview}
                          alt="Preview"
                        />
                      </div>
                      {uploads !== null && uploads.size !== undefined && (
                        <p style={{ whiteSpace: "nowrap" }}>
                          {uploads.size < 1000000
                            ? Math.round((uploads.size / 1000) * 100) / 100 +
                              " KB"
                            : Math.round((uploads.size / 1000000) * 100) / 100 +
                              " MB"}
                        </p>
                      )}
                      {!disabled && (
                        <p
                          style={{ cursor: "pointer", marginTop: "4px" }}
                          onClick={() => setPreview(null)}
                        >
                          {" "}
                          <CloseIcon
                            style={{
                              width: "18px",
                              height: "18px",
                              stroke: "#3B444D",
                            }}
                          />{" "}
                        </p>
                      )}
                    </div>
                  ) : (
                    <Fragment>
                      <input
                        required
                        type="file"
                        id="file"
                        style={{ display: "none" }}
                        accept="video/*, image/*"
                        onChange={(e) => handleUploads(e)}
                      />
                      <label htmlFor="file">
                        <p
                          style={{
                            color: "#3B444D",
                            padding: "20px",
                            textAlign: "center",
                            border: "1px solid #3B444D80",
                            margin: "20px 0px",
                            cursor: "pointer",
                          }}
                        >
                          Upload
                        </p>
                      </label>
                    </Fragment>
                  )}
                </div>

                <Button
                  type="submit"
                  disabled={disabled}
                  color="primary"
                  variant="contained"
                  style={{
                    padding: "1rem",
                    borderRadius: !merchantConfig.use_rounded_edge_buttons
                      ? "0px"
                      : "4px",
                    margin: "40px auto",
                    display: "block",
                    cursor: "pointer",
                    textTransform: "capitalize",
                  }}
                >
                  Save & Continue
                </Button>
              </form>
            </div>
          </Drawer>
          {/* {merchantConfig.whatsapp_help &&
            merchantConfig.whatsapp_help !== null && (
              <a
                href={merchantConfig.whatsapp_help}
                target="_blank"
                rel="noreferrer"
                className="help"
                style={{
                  color: "#3B444D",
                  padding: "20px 0px",
                  textDecoration: "underline",
                }}
              >
                Need Help?
              </a>
            )} */}
        </StyledTracking>
      )}
    </StyledApp>
  );
}

export default Tracking;
